import { useConfig } from '@/composables';
import axios, { AxiosInstance } from 'axios';
import { container, singleton } from 'tsyringe';
import { FirebaseAppCheck } from './firebase-app-check';

const config = useConfig();
const X_GV_CLIENT = 'ewa-web';

@singleton()
export class AxiosSingleton {
  public ewa: AxiosInstance;
  public s3: AxiosInstance;
  public readonly ewaPublicBff: AxiosInstance;

  constructor() {
    this.ewa = axios.create({
      baseURL: config.value.portalApi,
    });
    this.s3 = axios.create({
      baseURL: config.value.geospatialBucket,
    });

    this.ewaPublicBff = axios.create({
      baseURL: `${config.value.portalEwaBffApi}/public`,
      headers: {
        'x-gv-client': X_GV_CLIENT,
      },
    });

    this.ewaPublicBff.interceptors.request.use(async (config) => {
      config.headers['x-gv-client'] = X_GV_CLIENT;
      const appCheckToken = await container.resolve<FirebaseAppCheck>(FirebaseAppCheck).getToken();
      if (appCheckToken?.length) {
        config.headers['x-gv-app-check-token'] = appCheckToken;
      }
      return config;
    });
  }
}
